import React, { useState, useEffect, useRef } from 'react';
import TinyLoader from '../../../../Common/TinyLoader/TinyLoader';

const SERVICE_HEALTH_URL = process.env.REACT_APP_SERVICE_HEALTH_URL;

// Maximum time to wait for iframe onLoad before hiding the spinner anyway
const LOADER_TIMEOUT_MS = 10000;

const ServiceHealth = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const timerRef = useRef(null);

  const stopLoader = () => {
    setIsLoading(false);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => {
    // If the URL is missing or the iframe never fires onLoad, stop after timeout
    if (!SERVICE_HEALTH_URL) {
      setIsLoading(false);
      return;
    }
    timerRef.current = setTimeout(() => {
      setIsLoading(false);
    }, LOADER_TIMEOUT_MS);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <div>
      <div
        className="container-fluid m-1 createPo-wrapper-ss p-3"
        style={{ height: '100vh', display: 'flex', flexDirection: 'column', position: 'relative' }}
      >
        {/* Loader overlay — always on top, never hides the iframe */}
        {isLoading && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 10,
              background: 'inherit',
            }}
          >
            <TinyLoader />
          </div>
        )}

        {/* iframe always renders so onLoad fires reliably in all environments */}
        <iframe
          src={SERVICE_HEALTH_URL}
          title="Service Health"
          onLoad={stopLoader}
          onError={(err) => {
            console.log("errpr", err)
            stopLoader()}}
          style={{
            flex: 1,
            width: '111.11%',
            border: 'none',
            transform: 'scale(0.9)',
            transformOrigin: 'top left',
            height: '111.11%',
            visibility: isLoading ? 'hidden' : 'visible',
          }}
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default ServiceHealth;